<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web" style="height:auto">
            <br />            

            <div v-if="StudentList.length > 0">
              <h4 style="color: #000; text-align: left" class="custom-user-grade">
                Select Students
              </h4>
              <br />            
            
              <div class="list-grade">              
                <CCol v-for="(item, index) in StudentList" v-bind:key="item.Id" sm="12" class="">
                  <CRow class="" @click="GoToSubject(item.studentId, item.gradeId)">
                    <!-- <CCol> -->
                      <span v-if="item.studentProfilePhoto != null" class="ml-2">
                        <img 
                          :src="getPic(index)" 
                          width="50px"
                          height="50px"
                          style="border-radius: 30px;"
                        />
                      </span>

                      <span v-else class="ml-2">
                        <img 
                          src="../../assets/img/icon/icondefault.svg" 
                          width="50px"
                          height="50px" 
                          style="border-radius: 30px;"
                        />
                      </span>
                    <!-- </CCol>-->

                    <CCol class="ml-2"> 
                      <p class="" style="font-weight: 600; color: #000A2C; margin-bottom: 5px;"> {{ item.studentName}} </p>
                      <p class="form" style=" margin-bottom: 0px;"> {{ item.gradeName }} </p>
                    </CCol>
                  </CRow>
                  <div style="clear: both"></div>
                  <hr />
                </CCol>
              </div>
            </div>

            <div v-else>
              <h3
                style="text-align: left; margin: 20px 30px; font-weight: 600px; color: #000;"
                class="sub-title-header"
              >
                Register Student
              </h3>
              <h3
                style="text-align: left; margin: 20px 30px; font-weight: 400px; color: #000; font-size: 12px;"
                class="sub-title-header"
              >
              We noticed that you haven’t register student yet. Let’s register one below
              </h3>

              <img src="../../assets/img/icon/no-student.svg" />

              <div class="bottom-center text-center">
                <CButton  style="
                  position: fixed;
                  bottom: 30px;
                  left: 0px;
                  right: 0px;
                  text-align: center;
                  margin: 0 auto;" 
                  color="info" class="btn-select-blue mt-5" @click="GoToRegisterStudent()"
                >
                  Register Now
                </CButton>
              </div>
            </div>

          </div>

          <CModal title="Please update your grade." style="position: relative; width: 375px; height: 900px; border-radius: 32px;" size="" :show.sync="PopupUpdateGrade">
            <p></p>
            <div class="ml-3 mr-3">
              <v-select
              horizontal
              v-model="Grade"
              :options="grade"
              label="gradeName"
              placeholder="Select Grade"
            />
            </div>
            <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />
            <template #footer>
              <CButton color="success" @click="RefreshModal()">Cancel</CButton>

              <CButton color="info" @click="UpdateGrade()">Update</CButton>
            </template>
          </CModal>


        </div>
      </div>
      <MainlayoutBottom></MainlayoutBottom>
    </CContainer>

   

    <div style="clear: both"></div>
    <div class="header-top">Students</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import MainlayoutBottom from "../../containers/TheBottomCustom.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

export default {
  components: {
    MainlayoutBottom,
  },
  data () {
    return {
      user: {},
      StudentList: [],
      PopupUpdateGrade: false,
      grade: [],
      Grade: "",
      //StudentId: this
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetStudentList(this.user.id);
            this.GetGrade();
          }
        });
    },

    async GetStudentList() {
      this.$API
        .get(
          this.$GetStudentListByParentIdNew +
            "?userId=" +
            this.user.id,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentList = response.data;          
            this.getPic(this.StudentList.studentProfilePhoto);
            console.log("studentlist", this.StudentList);   

            for (let list = 0; list < this.StudentList.length; list++) {
              const studlist = this.StudentList[list];
              console.log("try", studlist.studentId);
            }
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },    

    getPic(index) {
      return (
        "https://pickiddo.com" + this.StudentList[index].studentProfilePhoto
      );
    },

    GetGrade() {
      this.$API
        .get(this.$GradeListAuthorize, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grade = response.data;
            this.FilterGrade = this.grade;
          }
        });
    },

    async RefreshModal() {
      this.PopupUpdateGrade = false;
    },

    UpdateGrade: function () {
      const formData = new FormData();
      formData.append("studentId", this.studentId);
      formData.append("grade", this.Grade.gradeName);

      return this.$API
        .post(this.$UpdateStudentGradeStatus, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Successfully Update").then(function () {});
            this.GoToRefresh();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },

    GoToRefresh() {
      window.location.reload();
    },
      
    
    GoToSubject(studentId, gradeId) {
      if(gradeId == 0) {
        this.studentId = studentId;
        this.PopupUpdateGrade = true;
        
      }
      else {
        const hasTeacherId = this.$route.query.hasOwnProperty('teacherId');

  if (hasTeacherId) {
    this.$router.push(
          "/FindTutor/FTSubject?studentId=" +
          studentId +
          "&gradeId=" +
          gradeId + "&teacherId=" + this.$route.query.teacherId);
  } else {
    this.$router.push(
          "/FindTutor/FTSubject?studentId=" +
          studentId +
          "&gradeId=" +
          gradeId
        );
  }


      }
      
    },

    GoToRegisterStudent() {
      this.$router.push(
        "/RegisterStudent" 
      );
    },
    
    GoBack() {
      this.$router.back();
    },
    
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input[type="text"] {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="checkbox"] {
opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.form {
    font-family: 'Montserrat';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 15px;
/* identical to box height */


/* #000A2C */

color: #000A2C;

}
</style>